import script from "./payments.vue?vue&type=script&setup=true&lang=ts"
export * from "./payments.vue?vue&type=script&setup=true&lang=ts"

import "./payments.vue?vue&type=style&index=0&id=7fb31f07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb31f07"]])

export default __exports__